<template>
  <div>
    <div class="container">
      <div class="data-filter">
        <div class="filter-item">
          <div
            v-for="(item, index) in categoryList"
            :key="index"
            :class="{ selected: item.id == categoryId }"
            @click="changeFilter(1, item.id)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="filter-item" v-show="true">
          <div
            v-for="(item, index) in labelList"
            :key="index"
            :class="{ selected: item.id == labelId }"
            @click="changeFilter(2, item.id)"
          >
            {{ item.lableName }}
          </div>
        </div>
        <div class="filter-item" v-show="true">
          <div
            v-for="(item, index) in majorList"
            :class="{ selected: item.majorid == majorId }"
            :key="index"
            @click="changeFilter(3, item.majorid)"
          >
            {{ item.majorname }}
          </div>
        </div>
        <div class="filter-item" v-show="true">
          <div
            v-for="(item, index) in specialList"
            :class="{ selected: item.id == specialId }"
            :key="index"
            @click="changeFilter(4, item.id)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="teacher">
      <div class="teacher-box-title">
        <img src="../../assets/images/teacher-t.png" alt />
      </div>

      <div class="teacher-box-pt" @click="searchData">搜索</div>
      <div class="teacher-box-two">
        <input
          v-model="keywords"
          type="text"
          placeholder="教师名称"
          class="input-one"
        />
      </div>
      <div class="remove-float"></div>
    </div>
    <div class="teacher-one clearfix">
      <router-link
        :to="{ name: 'TeacherDetail', params: { id: item.teacherId } }"
        class="teacher-view-one"
        v-for="(item, index) in teacherList"
        :key="index"
      >
        <div
          class="teacher-view-pt"
          :style="
            'background:url(' +
              concatImageUrl(item.pic1, 200, 265) +
              ') no-repeat center; background-size:cover;'
          "
        ></div>
        <div class="teacher-text-one">{{ item.tchName }}</div>
        <div class="teacher-text-two">{{ item.academy }}</div>
        <!-- <div class="tac" style="line-height: 1; height: 12px">
          <img src="../../assets/images/teacher-group.png" />
        </div> -->
      </router-link>
      <div class="page" v-show="totalCount > pageSize">
        <Page
          :total="totalCount"
          :current="pageIndex"
          :page-size="pageSize"
          @on-change="changePage"
        />
      </div>
      <div class="remove-float"></div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from '../../utils/mixin';
import { teacher } from '../../request';
import AppBanner from '../../components/common/AppBanner';
export default {
  mixins: [siteMixin],
  data() {
    return {
      categoryId: 0,
      categoryList: [],
      labelId: 0,
      labelList: [],
      majorId: '',
      majorList: [],
      specialId: 0,
      specialList: [],
      keywords: '',
      teacherList: [],
      pageIndex: 1,
      pageSize: 16,
      totalCount: 0,
    };
  },
  mounted() {
    this.setMetaData('师资团队');
    const { c, l, m, p, s, k } = this.$route.query;
    if (Number(c)) this.categoryId = c;
    if (Number(l)) this.labelId = l;
    if (m) this.majorId = m;
    if (Number(s)) this.specialId = s;
    if (Number(p)) this.pageIndex = Number(p);
    if (k) this.keywords = k;
    this.getFilgerList();
    this.getDataList();
  },
  methods: {
    getFilgerList() {
      teacher
        .getFilterList({
          agencyId: this.siteConfig.agencyId,
          typeId: this.categoryId,
          labelId: this.labelId,
          majorId: this.majorId,
        })
        .then(res => {
          //console.log(res);
          if (res.status === 1) {
            this.categoryList = res.data.dmTypes;
            this.labelList = res.data.lableList;
            this.majorList = res.data.majorList;
            this.specialList = res.data.specialTypeList;
          }
        });
    },
    getDataList() {
      teacher
        .getTeacherList({
          agencyId: this.siteConfig.agencyId,
          typeId: this.categoryId,
          labelId: this.labelId,
          majorId: this.majorId,
          specialTypeId: this.specialId,
          keywords: this.keywords,
          page: this.pageIndex,
          pageSize: this.pageSize,
        })
        .then(res => {
          //console.log(res);
          if (res.status === 1) {
            this.totalCount = res.data.total;
            this.teacherList = res.data.list;
          }
        });
    },
    searchData() {
      // if (!this.keywords) return;
      this.pageIndex = 1;
      this.$router.push({
        path: '/teacher',
        query: {
          c: this.categoryId,
          l: this.labelId,
          m: this.majorId,
          s: this.specialId,
          p: this.pageIndex,
          k: this.keywords,
        },
      });
      this.getDataList();
    },
    changeFilter(type, value) {
      switch (type) {
        case 1:
          this.categoryId = value;
          this.labelId = 0;
          this.majorId = '';
          this.specialId = 0;
          break;
        case 2:
          this.labelId = value;
          this.majorId = '';
          this.specialId = 0;
          break;
        case 3:
          this.majorId = value;
          this.specialId = 0;
          break;
        case 4:
          this.specialId = value;
          break;
        default:
          break;
      }
      this.pageIndex = 1;
      this.$router.push({
        path: '/teacher',
        query: {
          c: this.categoryId,
          l: this.labelId,
          m: this.majorId,
          s: this.specialId,
          p: this.pageIndex,
          k: this.keywords,
        },
      });
      this.getFilgerList();
      this.getDataList();
    },
    changePage(page) {
      this.scrollTop();
      this.pageIndex = page;
      this.$router.push({
        path: '/teacher',
        query: {
          c: this.categoryId,
          l: this.labelId,
          m: this.majorId,
          s: this.specialId,
          p: this.pageIndex,
          k: this.keywords,
        },
      });
      this.getDataList();
    },
  },
  components: {
    AppBanner,
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var.less';

.data-filter {
  width: 100%;
  margin: 10px auto;
  .filter-item {
    padding: 10px 0;
    div {
      display: inline-block;
      cursor: pointer;
      padding: 10px 20px;
      line-height: 1;
      font-size: 14px;
      background-color: #fff;
      border-radius: 8px;
      margin: 0 5px;
      color: #333;
      box-shadow: 1px 1px 3px #ccc;
      margin-bottom: 10px;
    }
    .selected {
      background-color: #0094ff;
      color: #fff;
    }
  }
}

.teacher {
  width: 1200px;
  /* height: 60px; */
  background: white;
  margin: 10px auto 0 auto;
  padding: 20px 1px 0 1px;
  .teacher-box-title {
    padding-bottom: 1.6rem;
    img {
      margin: 0 auto;
    }
  }
  .teacher-box-pt {
    width: 100px;
    height: 35px;
    line-height: 35px;
    float: right;
    background-color: #0094ff;
    text-align: center;
    border-radius: 30px;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    margin: 10px 20px 10px 0;
  }
  .teacher-box-two {
    /* width: 240px; */
    height: 35px;
    margin: 10px 10px 10px 0px;
    float: right;
    border: 1px solid #ccc;
    border-radius: 30px;
    background-color: #f5f5f5;
    .input-one {
      line-height: 30px;
      font-size: 14px;
      margin: 0 20px;
      outline: none;
      cursor: pointer;
      border: none;
      float: left;
      width: 260px;
      background-color: #f5f5f5;
    }
  }
  .remove-float {
    clear: both;
    height: 0;
    line-height: 0;
    font-size: 0;
  }
}

.teacher-one {
  width: 1200px;
  background: white;
  margin: 0 auto 20px auto;
  padding: 40px 20px;
  .teacher-view-one {
    width: 250px;
    float: left;
    padding: 12px;
    margin: 0 20px 30px 20px;
    border: 1px solid #ccc;
    border: 1px solid #ffffff;
    display: block;
    box-shadow: 0 0 8px #ccc;
    border-radius: 10px;
    .teacher-view-pt {
      width: 200px;
      height: 265px;
      background-color: #fff;
      text-align: center;
      margin: 0 auto;
      border-radius: 50% 50%;
      overflow: hidden;
      border: 1px solid #eee;
      box-shadow: 0 0 3px #eee;
    }
    .teacher-text-one {
      line-height: 32px;
      font-size: 18px;
      text-align: center;
      padding-top: 20px;
    }
    .teacher-text-two {
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      text-align: center;
    }
    .tac {
      img {
        margin: 0 auto;
      }
    }
  }
}
.page {
  text-align: center;
  margin: 20px auto 40px;
}
</style>
